import React from 'react';
import { ROLES } from './utils/roleUtils';

/**
 * Quick Stats Grid
 * 
 * Shows role-specific metrics at a glance.
 */
export default function MobileNavQuickStats({ role, user }) {
  // Get stats based on role
  const stats = getStatsForRole(role, user);
  
  if (!stats.length) return null;
  
  return (
    <div className={`grid grid-cols-${stats.length} gap-2 mb-6`}>
      {stats.map((stat, index) => (
        <div key={index} className="bg-white/5 rounded-xl p-3 text-center">
          <div className={`text-xl font-bold ${stat.color || 'text-white'}`}>
            {stat.value}
          </div>
          <div className="text-xs text-white/40">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}

function getStatsForRole(role, user) {
  switch (role) {
    case ROLES.BUSINESS:
      return [
        { value: user?.stats?.claims || 0, label: 'Claims' },
        { value: user?.stats?.redeemed || 0, label: 'Redeemed' },
        { 
          value: `${user?.stats?.redemption_rate || 0}%`, 
          label: 'Rate',
          color: 'text-green-400'
        },
      ];
    
    case ROLES.VENUE:
      return [
        { value: user?.stats?.total_scans || 0, label: 'Total Scans' },
        { value: user?.stats?.weekly_scans || 0, label: 'This Week' },
      ];
    
    case ROLES.ADMIN:
      return [
        { value: user?.stats?.total_businesses || 0, label: 'Businesses' },
        { value: user?.stats?.total_venues || 0, label: 'Venues' },
        { value: formatNumber(user?.stats?.total_users || 0), label: 'Users' },
      ];
    
    default:
      return [];
  }
}

function formatNumber(num) {
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}k`;
  }
  return num.toString();
}
